/* v8 ignore start */
import { createPinia } from 'pinia';
import { defineVueComponentAEM } from '@dh-io-owpi/shared/src/aem/vue';
import { createI18n } from '@dh-io-owpi/shared/src/plugins/i18n';
import { resetStores } from '@dh-io-owpi/shared/src/stores/store';
import { registerComponentInRUM } from '@dh-io-owpi/shared/src/utils/ddRum';

import App from './App.vue';

registerComponentInRUM();

const initPromise = !('ScrollTimeline' in window)
  ? import('./utils/scroll-timeline-polyfill').then((m) => m.initPolyfill())
  : Promise.resolve();

initPromise.then(() => {
  defineVueComponentAEM(App, import.meta.env.APP_NAME, [createI18n(), createPinia()]);
});

if (((window.top ?? window) as any).aemNamespace.pageEnvironmentVariables.runMode === 'AUTHOR') {
  document.addEventListener('component-updated', (event) => {
    const target = event.target as HTMLElement;
    const targetComponentName = target.getAttribute('data-component-name');

    if (target && targetComponentName === import.meta.env.APP_NAME) {
      resetStores();
    }
  });
}
